import { Component, ViewChild } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { ActivatedRoute, Router } from '@angular/router';
import {TopicService } from '../topic.service';
import { Location } from '@angular/common';

import { NgModel, NgForm } from '@angular/forms';
import { MessageService } from '../../shared/message.service';
@Component({
  selector: 'app-t-exam',
  templateUrl: './t-exam.component.html',
  styleUrls: ['../../General/tiles.css', './t-exam.component.css']
})
export class TExamComponent extends GeneralTeacherComponent {

  @ViewChild('definitionForm', {static:true}) public definitionForm: NgForm;

  isExamP: boolean = false;
  solveInOrder: boolean = false;
  level: number = 2;

  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService, protected _location: Location, protected messageService: MessageService, protected router: Router) {
    super(topicService, activatedRoute);
    this.type = "exam";
    this.title = this.get("exam");
    if (this.activatedRoute.snapshot.paramMap.has('examid')) {
      this.id = +this.activatedRoute.snapshot.paramMap.get('examid');
      this.setInformationWithConfiguration();
    }
  }

  generateDefinition(){
    let definition: any = {};
    definition.title = this.title;
    definition.description = this.description;
    definition.type = this.type;
    definition.image = "./assets/images/dataRepresentation.png";
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxExamId() + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.isExam = this.isExamP;
    if(!this.isExamP){
      definition.solveInOrder = this.solveInOrder;
    }
    if(this.configuration == undefined){
      definition.questions = [];
    } else {
    definition.questions = this.configuration.questions;
  }
  definition.level = this.level;
    return definition;
  };

  reset(){
    this.id = undefined;
    this.title = this.get("exam");
    this.description = "";
    this.isExamP = false;
    this.solveInOrder = false;
    this.level = 2;
  };

  setInformationWithConfiguration(){
    this.configuration = this.topicService.getExamById(this.id);
    this.title = this.configuration.title;
    this.description = this.configuration.description;
    this.isExamP = this.configuration.isExam;
    this.solveInOrder = this.configuration.solveInOrder;
  };

  update(){
    super.update();
    this.messageService.addAlertWithTimeout(this.get("exerciseUpdated"),"success", 10000);
  }

  add(){
    super.add(); 
    this.messageService.addAlertWithTimeout(this.get("exerciseAdded"),"success", 10000);
    this.router.navigate([this.id.toString()], { relativeTo: this.activatedRoute });
  }

  view() {
    this.router.navigateByUrl("/".concat(this.topicService.type, "/exam/", this.examId.toString()), { relativeTo: this.activatedRoute });
  }
}
